import * as React from "react";

function GiftIcon(props) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2.2"
			strokeLinecap="round"
			strokeLinejoin="round"
			height="1em"
			width="1em"
			{...props}
		>
			<rect x="3" y="8" width="18" height="4" rx="1" />
			<path d="M5 12v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8" />
			<path d="M12 8v13" />
			<path d="M12 8c-1.5-3-5-4-5.5-2S9 8 12 8Z" />
			<path d="M12 8c1.5-3 5-4 5.5-2S15 8 12 8Z" />
		</svg>
	);
}

export default GiftIcon;
